var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33335 0.583313H2.66669C1.69835 0.583313 0.916687 1.36498 0.916687 2.33331V11.6666C0.916687 12.635 1.69835 13.4166 2.66669 13.4166H7.33335C8.30169 13.4166 9.08335 12.635 9.08335 11.6666V2.33331C9.08335 1.36498 8.30169 0.583313 7.33335 0.583313ZM6.16669 12.25H3.83335V11.6666H6.16669V12.25ZM7.91669 10.5H2.08335V2.33331H7.91669V10.5Z",
    fill: "#001C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffPhone);
export default __webpack_public_path__ + "static/media/staffPhone.f2645bbd58ec03c20988e4b66d8bbc93.svg";
export { ForwardRef as ReactComponent };